module.exports = "<span class=\"cote-p cote-type-<%=type%>\"><%=cote%></span>";